export const config = {
    defaults: {
        queries: {
            limit: 50,
            searchLimit: 5,
        },
    },
};
